<script>
    import TablaGelesSachet from "./GelesRefrigerantesTabla.svelte";
    var sachet = false;
    function mostrarDiv(id){
            sachet = !sachet;
    }
</script>
<div class="row">
    <div class="col-2 col-lg-8 linea">
    </div>
    <div class="col-10 col-lg-4">
        <h2>Geles En Sachet</h2>
    </div>
</div>
<div class="row">
    <div class="col-6 col-lg-2">
        <div class="cards">
            <img class="card-img-top" src="img/Low/gel150Cuad.png" alt="Gel refrigerante 150 gramos ICEMAGELES">
          </div>
    </div>
    <div class="col-6 col-lg-2">
        <div class="cards">
            <img class="card-img-top" src="img/Low/gel300.png" alt="Gel refrigerante 300 gramos ICEMAGELES">
          </div>
    </div>
    <div class="col-6 col-lg-2">
        <div class="cards">
            <img class="card-img-top" src="img/Low/gel350.png" alt="Gel refrigerante 350 gramos ICEMAGELES">
          </div>
    </div>
    <div class="col-6 col-lg-2">
        <div class="cards">
            <img class="card-img-top" src="img/Low/gel-500.png" alt="Gel refrigerante 500 gramos ICEMAGELES">
          </div>
    </div>
    <div class="col-6 col-lg-2">
        <div class="cards">
            <img class="card-img-top" src="img/Low/gel600.png" alt="Gel refrigerante 600 gramos ICEMAGELES">
          </div>
    </div>
    <div class="col-6 col-lg-2">
        <div class="cards">
            <img class="card-img-top" src="img/Low/gel800.png" alt="Gel refrigerante 800 gramos ICEMAGELES">
          </div>
    </div>
    <div class="col-12 top-20">
            <ul>
                <li>
                    Son un polímero sintético de la más alta calidad, reutilizable, NO toxico, económico y con propiedades refrigerantes
                    <hr>
                </li>
                <li>
                    Usado en varias industrias, para conservar y transportar en cadena de frío cualquier producto
                    <hr>
                </li>
                <li>
                    <strong>Se pueden realizar con logos personalizados a pedido</strong>
                </li>
            </ul>
    </div>
    <div class="col-12" style="text-align:center;">
        <button class="boton-info" on:click={() => mostrarDiv("sachet")}>+Info</button>
    </div>
</div>

{#if sachet}
    <TablaGelesSachet />
{/if}